import { GameSession } from "../../GameSession";
import { FreegameStates } from "./FreegameState";

// holds values of freegame
export class FreegameSession extends GameSession
{
	
	public state: FreegameStates = FreegameStates.Idle;

	public awarded: number = 0;
	public played: number = 0;
	public left: number = 0;
	//public win: number = 0;
	public totalWin: number = 0 ;
	public winDuration: number = 0;

	constructor() {
		super();
	} 

	public static FromValues(state: FreegameStates, awarded: number, played: number, left: number, win:number, totalWin:number, winDuration: number): FreegameSession {
		
		let fgs = new FreegameSession();

		fgs.state = state;
		fgs.awarded = awarded;
		fgs.played = played,
		fgs.left = left;
		//fgs.win = win;
		fgs.totalWin = totalWin;
		fgs.winDuration = winDuration;

		return fgs;
	}

	public Reset(): void
	{
		this.awarded = 0;
		this.played = 0;
		this.left = 0;
		//this.win = 0;
		this.totalWin = 0 ;
		this.winDuration= 0;
	}

	public Update(newSession: FreegameSession)
	{
		this.awarded = newSession.awarded;
		this.played = newSession.played;
		this.left = newSession.left;
		//this.win = newSession.win;
		this.totalWin = newSession.totalWin;
		this.winDuration= newSession.winDuration;
	}
}